export default __webpack_public_path__ + "static/media/1522.a4378771.png";